import React, { useState, useEffect } from "react";
import ButtonFill from "../../../components/button/ButtonFill";
import camilaCabello from "../../../media/images/camila-cabello1-nobg.png";
import arianaGrande from "../../../media/images/ariana-grande1-nobg.png";
import charliePuth from "../../../media/images/charlie-puth1-nobg.png";
import arianaGrandePlayer from "../../../media/images/ariana-grande1.jpg";
import camilaCabelloPlayer from "../../../media/images/camila-cabello1.jpg";
import charliePuthPlayer from "../../../media/images/charlie-puth1.jpg";
import tynAudio from "../../../media/audio/tyn.mp3";
import itdAudio from "../../../media/audio/itd.mp3";
import attentionAudio from "../../../media/audio/attention.mp3";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { playNewSong, setplay } from "../../../redux/actions/player";
import MusicBars from "../../../components/animation/MusicBars";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import TooltipPrimary from "../../../components/tooltips/TooltipPrimary";
import { setselectedAddPlaylist } from "../../../redux/actions/music";

const data = [
  {
    id: 1,
    title: "Trending New Hits",
    song: "Thank You Next",
    artist: "Ariana Grande",
    plays: 89,
    artistImg: arianaGrande,
    player: {
      name: "Thank You Next",
      artist: "Ariana Grande",
      duration: "3:27",
      img: arianaGrandePlayer,
      audio: tynAudio,
      color: "47, 79, 182",
      video:
        "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Ariana%20Grande%20-%20thank%20u%20next.mp4?alt=media&token=a6b39a92-a07b-4578-9f8a-bca728332203",
    },
  },
  {
    id: 2,
    title: "Trending New Hits",
    song: "In The Dark",
    artist: "Camila Cabello",
    plays: 77,
    artistImg: camilaCabello,
    player: {
      name: "In The Dark",
      artist: "Camila Cabello",
      duration: "3:41",
      img: camilaCabelloPlayer,
      audio: itdAudio,
      color: "130, 107, 75",
      video:
        "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Camila%20Cabello%20-%20Never%20Be%20the%20Same_Full-HD.mp4?alt=media&token=5321e9a9-93ad-4d01-bc9f-6a4b1b0f89d3",
    },
  },

  {
    id: 3,
    title: "Trending New Hits",
    song: "Attention",
    artist: "Charlie Puth",
    plays: 87,
    artistImg: charliePuth,
    player: {
      name: "Attention",
      artist: "Charlie Puth",
      duration: "3:31",
      img: charliePuthPlayer,
      audio: attentionAudio,
      color: "40, 88, 128",
      video:
        "https://firebasestorage.googleapis.com/v0/b/music-app-37b90.appspot.com/o/Charlie%20Puth%20-%20Attention%20%5BOfficial%20Video%5D.mp4?alt=media&token=983cfb32-4382-43d6-b806-423d967d546c",
    },
  },
];
const Trending = (props) => {
  const { musicPlayerRef } = props;
  const dispatch = useDispatch();
  const AC = bindActionCreators({ playNewSong, setplay }, dispatch);

  const { currentSong, play } = useSelector((state) => state.player);

  const [currentScreen, setcurrentScreen] = useState(1);

  function onClickUp() {
    if (currentScreen > 1) {
      setcurrentScreen(currentScreen - 1);
    } else {
      setcurrentScreen(data.length);
    }
  }

  function onClickDown() {
    if (currentScreen < data.length) {
      setcurrentScreen(currentScreen + 1);
    } else {
      setcurrentScreen(1);
    }
  }

  useEffect(() => {
    let screenTimeOut;
    if (currentSong.name !== data[currentScreen - 1].player.name) {
      screenTimeOut = setTimeout(() => {
        if (currentScreen === data.length) {
          setcurrentScreen(1);
        } else {
          setcurrentScreen(currentScreen + 1);
        }
      }, 10000);
    }

    return () => clearTimeout(screenTimeOut);
  }, [currentScreen, currentSong]);

  function onClickPlay(song) {
    AC.playNewSong(song);
    AC.setplay(true);
    musicPlayerRef.current.scrollIntoView({ behavior: "smooth" });
  }

  function onPause() {
    AC.setplay(false);
  }

  return (
    <div className="trending">
      {data.map(
        (item) =>
          item.id === currentScreen && (
            <div key={item.id} className="content">
              <div className="left">
                <p className="title">{item.title}</p>
                <h1 className="song">{item.song}</h1>
                <div className="flex">
                  <h3 className="artist">{item.artist}</h3>
                  <p className="plays">{item.plays} million plays</p>
                </div>
                <div className="actions">
                  {play && currentSong.name === item.player.name ? (
                    <ButtonFill text="Pause" iconLeft={<PauseIcon />} onClick={onPause} />
                  ) : (
                    <ButtonFill text="Play Now" iconLeft={<PlayArrowIcon />} onClick={() => onClickPlay(item.player)} />
                  )}
                  <TooltipPrimary
                    className="fav"
                    text="Add to playlist"
                    onClick={() => dispatch(setselectedAddPlaylist(item.player))}
                  >
                    <PlaylistAddIcon />
                  </TooltipPrimary>
                  {play && currentSong.name === item.player.name && <MusicBars />}
                </div>
              </div>
              <div className="right">
                <div className="artist-img">
                  <img src={item.artistImg} alt={item.artist} />
                </div>
              </div>
            </div>
          )
      )}
      <div className="toggle">
        <div className="indicators">
          {data.map((item) => (
            <div key={item.id} className={`indicator ${item.id === currentScreen ? "indicator-active" : ""}`} />
          ))}
        </div>

        <div className="actions">
          <div className="up" id="up" onClick={onClickUp}>
            <ExpandLessRoundedIcon />
          </div>
          <div className="down" id="down" onClick={onClickDown}>
            <ExpandMoreRoundedIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trending;
